/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/button-has-type */

import * as React from 'react';
import Popup from 'reactjs-popup';
import { MediaPreviewState } from 'stageclip-common';

import styles from './mediaPreviewCell.module.scss';

interface AudioPreviewStateOwnProps {
  state: MediaPreviewState;
  link: string;
}

export class MediaPreviewCell extends React.Component<AudioPreviewStateOwnProps> {
  private renderState(state: MediaPreviewState) {
    switch (state) {
      case MediaPreviewState.NotAvailable:
        return <span className={styles.notAvailable}>Not Available</span>;
      case MediaPreviewState.Error:
        return <span className={styles.error}>Error</span>;
      case MediaPreviewState.Processing:
        return <span className={styles.processing}>Processing</span>;
      case MediaPreviewState.SentToGenerator:
        return <span className={styles.sentToGenerator}>Sent to generator</span>;
      case MediaPreviewState.Available:
        return this.renderAudioPreviewButton();
      default:
        return '';
    }
  }

  private renderAudioPreviewButton() {
    return (
      <Popup
        trigger={<button className={styles.available}>Play</button>}
        position="top center"
        closeOnDocumentClick
        contentStyle={{ width: 'unset' }}
      >
        <span>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <audio controls autoPlay src={this.props.link} />
        </span>
      </Popup>
    );
  }

  public render() {
    return <div> {this.renderState(this.props.state)} </div>;
  }
}
